export default __webpack_public_path__ + "static/media/clearing-bin-icon.0a56ee9f.svg";